import { get } from 'lodash';
import React from 'react';
import { ANTRAG_VERBUNDPARTNER } from 'src/lib/constants/componentsPath';
import { ANTRAGBERECHTIGTE_TYP, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import FoerderprojekteSkizzeGlobal, { getFormStrucFoerderprojekteSkizzeGlobal } from './content/FoerderprojekteSkizzeGlobal';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import { getAntragstellerName, getVerbundPartnerName } from '../../../application-helper-function/AppHelperfunctions';
const P = Schema.attributes;

export const TreestructureFoerderprojekteSkizzeGlobal = (application: any, _readOnly: boolean) => {
	let treeNodes: TreeNodeType[] = [];

	const isHochschule =
		get(application, P.Organisation_Antragsberechtigt_Als.schema.attributes.Allgemein_Typ.path) === ANTRAGBERECHTIGTE_TYP.Forschungseinrichtung;
	const antragstellerName = getAntragstellerName(application);
	treeNodes = [
		{
			label: 'Übersicht Förderprojekte',
			content: <ApplicationHeading title='Übersicht Förderprojekte' description={PLATZHALTER_TEXT} />,
			children: [
				{
					label: `Förderprojekte: ${antragstellerName}`,
					content: (
						<FoerderprojekteSkizzeGlobal
							unternehmenId={get(application, `${P.Antragstellende_Organisation.path}.id`)}
							unternehmenName={antragstellerName}
							isHochschule={isHochschule}
						/>
					),
					formStruc: getFormStrucFoerderprojekteSkizzeGlobal(
						application,
						get(application, `${P.Antragstellende_Organisation.path}.id`),
						isHochschule,
					),
				},
				...get(application, P.Verbundpartner.path, []).map((ele: any, i: number) => {
					const isVpartnerHochschule =
						get(ele, `${ANTRAG_VERBUNDPARTNER.Antragberechtigt}.attributes.Allgemein_Typ`) === ANTRAGBERECHTIGTE_TYP.Forschungseinrichtung;
					const vPartnerName = get(ele, ANTRAG_VERBUNDPARTNER.Name) ? get(ele, ANTRAG_VERBUNDPARTNER.Name) : `Verbundpartner ${i + 1}`;

					return {
						label: `Förderprojekte: ${getVerbundPartnerName(ele, i)}`,
						content: (
							<FoerderprojekteSkizzeGlobal
								unternehmenId={get(ele, `${ANTRAG_VERBUNDPARTNER.Partner}.id`)}
								positionId={get(ele, ANTRAG_VERBUNDPARTNER.PositionID)}
								unternehmenName={vPartnerName}
								isHochschule={isVpartnerHochschule}
							/>
						),
						formStruc: getFormStrucFoerderprojekteSkizzeGlobal(
							application,
							get(ele, `id`),
							isVpartnerHochschule,
							get(ele, ANTRAG_VERBUNDPARTNER.PositionID),
						),
					};
				}),
			],
		},
	];

	return treeNodes;
};
